// extracted by mini-css-extract-plugin
export default {"neutralWhite":"#fff","primary":"#dae029","spinner":"style_spinner__IRYUD","spin":"style_spin__AQ1UD"};